module.exports = __webpack_public_path__ + "media/images/img_ogp_blank-5ff5817c1c479b5b35ec5cee8fe97733.png";